import { Component, OnInit, } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DatabaseService } from 'src/_services/DatabaseService';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { sessionStorage } from 'src/app/localstorage.service';
import { DialogComponent } from 'src/app/dialog.component';
import { ToastrManager } from 'ng6-toastr-notifications';
import { AddItemComponent } from 'src/app/add-item/add-item.component';
import { StatusModalComponent } from 'src/app/order/status-modal/status-modal.component';
import { ImageModuleComponent } from 'src/app/image-module/image-module.component';


@Component({
    selector: 'app-dr-complaint-detail',
    templateUrl: './dr-complaint-detail.component.html',
    styleUrls: ['./dr-complaint-detail.component.scss']
})
export class DrComplaintDetailComponent implements OnInit {
    
    orderType: any = 'order';
    status: any;
    url: any;
    skLoading: boolean = false;
    nexturl:any;
    data: any = {};
    login_data: any = [];
    complaint_id: any;
    complaint_item: any = [];
    invoice_bill_item: any = [];
    order_logs: any = [];
    complaint_detail: any = [];
    login_dr_id: any;
    editqty: any = false;
    distrbutorId: any;
    constructor(public route: ActivatedRoute, public serve: DatabaseService, public toast: ToastrManager, public dialog: MatDialog, public session: sessionStorage, public dialogs: DialogComponent, public router: Router, public alert: DialogComponent) {
        this.url = this.serve.uploadUrl + 'complaint_doc/';
        
        this.login_data = this.session.getSession();
        this.login_data = this.login_data.value.data;
        console.log( this.login_data);
        console.log('Type ID = ', this.login_data.type);
        
        
        this.route.params.subscribe(params => {
            this.complaint_id = params.id;
            this.serve.currentUserID = params.id
            this.status = this.route.queryParams['_value']['status'];
            
        });
        this.drComplaintDetail();
    }
    
    ngOnInit() {}
    
    
    loader: any;
    edit_cash_discount: any = false;
    Order_Amount: any;
    drComplaintDetail() {
        this.loader = 1;
        this.skLoading = true;
        let id = { 'id': this.complaint_id }
        
        setTimeout(() => {
            this.serve.post_rqst(id, "Support/complainDetails").subscribe((result => {
                if (result['statusCode'] == 200) {
                    this.skLoading = false;
                    this.complaint_detail = result['result'];
                    this.distrbutorId = this.complaint_detail['dr_id'];
                    this.complaint_item = result['result']['complain_items'];
                    
                    this.Order_Amount = Number(this.complaint_detail.order_total) + Number(this.complaint_detail.order_discount)
                    this.complaint_item.map((row) => {
                        row.editqty = false
                    })
                    setTimeout(() => {
                        this.loader = '';
                    }, 700);
                } else {
                    setTimeout(() => {
                        this.loader = '';
                    }, 700);
                    this.skLoading = false;
                    this.toast.errorToastr(result['statusMsg'])
                }
            }))
        }, 700);
    }
    
    openDialog(complaint_status,total_approved_amt): void {
        const dialogRef = this.dialog.open(StatusModalComponent, {
            width: '400px' ,
            data: {
                'total_approved_amt': total_approved_amt,
                'order_status': complaint_status,
                'complaint_id': this.complaint_id,
                'from': 'complaint_status',
            }
        });
        
        dialogRef.afterClosed().subscribe(result => {
            if (result != false) {
                this.drComplaintDetail();
            }
        });
    }
    
    deleteOrderitem(complaint_id, index) {
        this.alert.confirm("You want to delet this item !").then((result) => {
            if (result) {
                this.serve.post_rqst({ 'id': complaint_id }, "Order/primaryOrderDeleteItem")
                .subscribe((result => {
                    if (result['status'] == 200) {
                        this.toast.successToastr('Item Deleted Successfully');
                        this.complaint_item.splice(index, 1)
                        this.drComplaintDetail();
                    } else {
                        this.drComplaintDetail();
                        this.toast.errorToastr(result['status'])
                    }
                }))
            }
        })
    }
    
    // }
    complaint_detail1: any = {}
    edit_qty() {
        this.editqty = true;
    }
    Update_qty(id) {
        let index = this.complaint_item.findIndex(row => row.id == id)
        let cart_data = []
        let Amount = (this.complaint_item[index].qty * this.complaint_item[index].net_price)
        this.complaint_item[index].product_price = this.complaint_item[index].price
        this.complaint_item[index].discounted_price = this.complaint_item[index].discount_amount
        this.complaint_item[index].dr_disc = this.complaint_item[index].discount_percent
        this.complaint_item[index].amount = Amount
        this.complaint_item[index].gst_amountbeforfix = (Amount * this.complaint_item[index].gst_percent) / 100
        this.complaint_item[index].gst_amount = parseFloat(this.complaint_item[index].gst_amountbeforfix).toFixed()
        this.complaint_item[index].total_amount = parseFloat(this.complaint_item[index].gst_amount) + Amount;
        cart_data.push(this.complaint_item[index])
        
        this.serve.post_rqst({ 'id': id, 'cart_data': cart_data }, "order/primaryOrderUpdateItem").subscribe((result => {
            if (result['statusCode'] == 200) {
                this.editqty = false;
                this.toast.successToastr(result['statusMsg']);
                this.drComplaintDetail()
            }
            else {
                this.editqty = false;
                this.toast.errorToastr(result['statusMsg']);
            }
        }))
    }
    
    
    amount: any = 0;
    gst_amount: any = 0;
    subtotal: any = 0;
    second_subtotal: any = 0;
    cd_amount: any = 0;
    
    back(){
        if (this.login_data.type == '1') {
            this.nexturl = this.route.snapshot.queryParams['returnUrl'] || '/distribution-list/1/Channel%20Partner/distribution-detail/'+this.login_data['id']+'/'+'DrComplaint';
            this.router.navigate([this.nexturl]);
        }
        else
        {
            this.router.navigate(['/support'])
        }
        
    }
    
    getAmount(price,qty,index)
    {
        console.log('get amount' , price , qty)
        this.complaint_item[index].approved_amt = parseInt(price) * parseInt(qty);
        console.log(this.complaint_item[index].approved_amt,'amt')
    }
    
    saveUpdatedItems() {
        this.serve.post_rqst({ 'complaint_id': this.complaint_id, 'complaint_item' : this.complaint_item}, "Support/complainApprove")
        .subscribe((result => {
            console.log(result);
            
            if (result['statusCode'] == 200) {
                this.toast.successToastr('Item Updated Successfully');
                this.drComplaintDetail();
            } else {
                this.drComplaintDetail();
                this.toast.errorToastr(result['statusMsg'])
            }
        }))
    }
    
    imageModel(image) {
        const dialogRef = this.dialog.open(ImageModuleComponent, {
            panelClass: 'Image-modal',
            data: {
                image,
            }
        });
        dialogRef.afterClosed().subscribe(result => {
            console.log(result);
        });
    }
    
}